import React, { useContext } from 'react'
import moment from 'moment'

import './EventCard.css'
import { SPContext } from '../../SPContext'
import { withRouter } from 'react-router-dom'
import { Row, Col, Card, CardHeader, CardBody, CardImg, UncontrolledTooltip } from 'reactstrap'

import EventEdit from '../event/EventEdit'

const EventCard = withRouter(
    React.memo(
        ({
            main_title,
            section,
            item_event,
            setEvent,
            handleOpenEventModal,
            eventLikePost,
            eventGoingPost,
            eventInterestedPost,
            user_id,
            history,
            users,
            event_types,
            isAdmin,
            inAdminPage,
        }) => {
            const payment_type =
                (item_event.event_FK_event_price_type_id &&
                    event_types.length &&
                    event_types.find(et => et.id === item_event.event_FK_event_price_type_id)) ||
                {}

            const UserControllers = props => {
                return (
                    <div>
                        <EventEdit item_event={item_event} />
                        {/* <DeleteEvent /> */}
                    </div>
                )
            }

            // const DeleteEvent = props => {
            //   return (
            //     <div
            //       id={'event-delete-' + item_event.event_id}
            //       className={'sp-card-delete-icon'}
            //       onClick={e => eventDeletePost(e, item_event.event_id)}
            //     >
            //       <i className='sp-card-delete-icon far fa-trash-alt' />
            //     </div>
            //   )
            // }

            // const eventDeletePost = () => {}

            const span_main_title = () => {
                return <span className='sp-card-top-text'>{main_title.title}</span>
            }
            const main_section = section === 'main'
            const viewEvent = () => history.push(`/event/view/${item_event.event_id}`)
            const going_disabled =
                (!!!~item_event.going.indexOf(user_id) &&
                    item_event.going.length >= item_event.event_needed_max) ||
                item_event.event_FK_event_status_id === '5'

            const ownerOrAdmin =
                parseInt(item_event.event_FK_created_by_user_id, 10) === user_id ||
                (isAdmin && inAdminPage)

            return (
                <Col xs='12' md='6' lg='4' className=''>
                    <Card
                        className={
                            'sp-card' +
                            (item_event.event_FK_event_status_id === '5' ? ' closed' : '') +
                            (main_section ? ' sp-card-main-section' : '')
                        }
                    >
                        {main_section ? span_main_title() : ''}

                        <CardBody>
                            <CardImg
                                height=''
                                className='sp-card-img'
                                style={{ objectFit: 'cover', height: '208px' }}
                                src={item_event.main_image || '/images/default_image.jpg'}
                                alt='Card image cap'
                                onClick={viewEvent}
                            />
                            <img
                                alt={payment_type.label}
                                src={`images/payment-${payment_type.id}.png`}
                                className='funded pointer'
                                onClick={viewEvent}
                            />
                            {ownerOrAdmin ? <UserControllers /> : ''}
                        </CardBody>
                        <CardHeader>
                            {/* <div
                className='btn sp-card-link-button mt-3 mb-3 fixed-position-button pointer'
                onClick={viewEvent}
              >
                VIEW THE EVENT
              </div> */}
                            <Row>
                                <Col className='sp-card-footer-category'>
                                    {item_event.categories
                                        ? item_event.categories.map((category, i) => [
                                              i > 0 && '& ',
                                              <span
                                                  key={`event_card_category_${category.category_id}`}
                                              >
                                                  {category.category_label}
                                              </span>,
                                          ])
                                        : null}
                                </Col>
                                <div className='col-12 event-title'>{item_event.event_title}</div>
                            </Row>

                            <Row>
                                <Col className='sp-card-footer-event-date mt-2 mt-lg-3'>
                                    {moment(item_event.event_date_start).format(
                                        'dddd, Do MMMM YYYY',
                                    )}
                                </Col>
                            </Row>
                            <Row className='icons-row'>
                                {/* <!-- INTERESTED (begin) --> */}
                                <Col>
                                    {item_event.going.length >= item_event.event_needed_max && (
                                        <>
                                            <span>{item_event.interested.length}x</span>
                                            <div
                                                id={'event-interested-' + item_event.event_id}
                                                color='sp-card-head-like-color'
                                                className={
                                                    'btn sp-card-head-like-button ' +
                                                    (!going_disabled ||
                                                    item_event.event_FK_event_status_id === '5'
                                                        ? ' disabled'
                                                        : 'pointer') +
                                                    (!!~item_event.interested.indexOf(user_id)
                                                        ? ' interested'
                                                        : '')
                                                }
                                                onClick={() =>
                                                    going_disabled &&
                                                    item_event.event_FK_event_status_id !== '5' &&
                                                    eventInterestedPost(
                                                        item_event.event_id,
                                                        !~item_event.interested.indexOf(user_id),
                                                    )
                                                }
                                            >
                                                <img src='/images/star.svg' alt='Interested' />
                                            </div>

                                            {(item_event.interested &&
                                                item_event.interested.length && (
                                                    <UncontrolledTooltip
                                                        placement='bottom'
                                                        target={
                                                            'event-interested-' +
                                                            item_event.event_id
                                                        }
                                                    >
                                                        {users &&
                                                            users
                                                                .filter(
                                                                    user =>
                                                                        ~item_event.interested.indexOf(
                                                                            parseInt(user.id),
                                                                        ),
                                                                )
                                                                .map(
                                                                    user =>
                                                                        user.first_name +
                                                                        ' ' +
                                                                        user.last_name,
                                                                )
                                                                .sort()
                                                                .map((user_name, i) => (
                                                                    <div key={`likes-user-${i}`}>
                                                                        {user_name}
                                                                    </div>
                                                                ))}
                                                    </UncontrolledTooltip>
                                                )) ||
                                                null}
                                        </>
                                    )}
                                </Col>
                                {/* <!-- INTERESTED (end) --> */}

                                {/* <!-- GOING (begin) --> */}
                                <Col>
                                    <span>{item_event.going.length}x</span>
                                    <div
                                        id={'event-going-' + item_event.event_id}
                                        color='sp-card-head-like-color'
                                        className={
                                            'btn sp-card-head-like-button ' +
                                            ((going_disabled && ' disabled') || 'pointer') +
                                            (!!~item_event.going.indexOf(user_id) ? ' going' : '')
                                        }
                                        onClick={() =>
                                            !going_disabled &&
                                            item_event.event_FK_event_status_id !== '5' &&
                                            eventGoingPost(
                                                item_event.event_id,
                                                !~item_event.going.indexOf(user_id),
                                            )
                                        }
                                    >
                                        <img src='/images/avatar.svg' alt='Going' />
                                    </div>

                                    {(item_event.going && item_event.going.length && (
                                        <UncontrolledTooltip
                                            placement='bottom'
                                            target={'event-going-' + item_event.event_id}
                                        >
                                            {users &&
                                                users
                                                    .filter(
                                                        user =>
                                                            ~item_event.going.indexOf(
                                                                parseInt(user.id),
                                                            ),
                                                    )
                                                    .map(
                                                        user =>
                                                            user.first_name + ' ' + user.last_name,
                                                    )
                                                    .sort()
                                                    .map((user_name, i) => (
                                                        <div key={`likes-user-${i}`}>
                                                            {user_name}
                                                        </div>
                                                    ))}
                                        </UncontrolledTooltip>
                                    )) ||
                                        null}
                                </Col>
                                {/* <!-- GOING (end) --> */}

                                {/* <!-- LIKE  (begin) --> */}
                                <Col>
                                    <span>{item_event.likes.length}x</span>
                                    <div
                                        id={'event-likers-' + item_event.event_id}
                                        color='sp-card-head-like-color'
                                        className={
                                            'btn sp-card-head-like-button ' +
                                            (item_event.event_FK_event_status_id === '5'
                                                ? 'disabled'
                                                : 'pointer') +
                                            (!!~item_event.likes.indexOf(user_id) ? ' liked' : '')
                                        }
                                        onClick={() =>
                                            item_event.event_FK_event_status_id !== '5' &&
                                            eventLikePost(
                                                item_event.event_id,
                                                !~item_event.likes.indexOf(user_id),
                                            )
                                        }
                                    >
                                        <img src='/images/heart.svg' alt='Like' />
                                    </div>

                                    {(item_event.likes && item_event.likes.length && (
                                        <UncontrolledTooltip
                                            placement='bottom'
                                            target={'event-likers-' + item_event.event_id}
                                        >
                                            {users &&
                                                users
                                                    .filter(
                                                        user =>
                                                            ~item_event.likes.indexOf(
                                                                parseInt(user.id),
                                                            ),
                                                    )
                                                    .map(
                                                        user =>
                                                            user.first_name + ' ' + user.last_name,
                                                    )
                                                    .sort()
                                                    .map((user_name, i) => (
                                                        <div key={`likes-user-${i}`}>
                                                            {user_name}
                                                        </div>
                                                    ))}
                                        </UncontrolledTooltip>
                                    )) ||
                                        null}
                                </Col>
                                {/* <!-- LIKE  (end) --> */}
                            </Row>
                        </CardHeader>
                    </Card>
                </Col>
            )
        },
    ),
)

const EventCardContainer = React.memo(props => {
    const {
        handleOpenEventModal,
        eventLikePost,
        eventGoingPost,
        eventInterestedPost,
        user_id,
        users,
        event_types,
        setEvent,
        isAdmin,
        inAdminPage,
    } = useContext(SPContext)
    return (
        <EventCard
            handleOpenEventModal={handleOpenEventModal}
            eventLikePost={eventLikePost}
            eventGoingPost={eventGoingPost}
            eventInterestedPost={eventInterestedPost}
            user_id={user_id}
            users={users}
            event_types={event_types}
            setEvent={setEvent}
            isAdmin={isAdmin}
            inAdminPage={inAdminPage}
            {...props}
        />
    )
})

export default EventCardContainer
